import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgQuicksilverModule } from 'ng-quicksilver';
import { DwLayoutBasicSideComponent } from './basic-side/basic-side.component';
import { DwLayoutDefaultComponent } from './layout-default/layout-default.component';
import { RouterModule } from '@angular/router';
import { DwMenusModule } from '../menu/menus.module';
import { DwLanguageModule } from '../language/language.module';
import { DwLoadingModule } from '../loading/loading.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgQuicksilverModule,
    DwMenusModule,
    DwLanguageModule,
    DwLoadingModule
  ],
  declarations: [
    DwLayoutBasicSideComponent,
    DwLayoutDefaultComponent
  ],
  exports: [
    DwLayoutBasicSideComponent,
    DwLayoutDefaultComponent
  ]
})
export class DwLayoutModule {}
